    <template>
    <div class="feedback-finish">
        <info-default
            :title="title"
            :descInfo="descInfo"
            imageUrl="svg"
            actionName="goReport"
            :textButton="$t('views.feedback.finish.textButton')"
            :noStyle="false">
            <Heart class="svg-icon"></Heart>
        </info-default>
    </div>
</template>
<script>
import InfoDefault from '../../components/shared/default/InfoDefault.vue'
import Heart from '../../components/shared/customIcons/Heart'
import { Bus } from '../../event-bus.js'
export default {
    components : {
        InfoDefault,Heart
    },
    data(){
        return{
            smallTitle: this.$t("views.feedback.finish.smallTitle"),
            title: this.$t("views.feedback.finish.title"),
            descInfo: this.$t("views.feedback.finish.descInfo")
        }
    },
    created(){
        Bus.$on('goReport', this.goReport)
    },
    destroyed(){
        Bus.$off('goReport')
    },
    methods: {
        goReport(){
            this.$router.push('/dashboard')
        }
    }
}
</script>
<style lang="scss">
.svg-icon{
    min-width: 200px;
    margin: 0 0 32px;    
}
.feedback-finish {
    height: 100%;
}
@media screen and (max-width: 639px){
    .feedback-finish .info-default .info-container .title-info{
        position: relative;

        .shadow{
            font-size: 38px;
            margin-left: 5px;
            position: absolute;
            top: 2px;
            left: auto;             
        }
        .title{
            font-size: 38px;
        }
    } 
}
</style>
